var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.416 78.5C61.7368 78.5 78.916 61.3208 78.916 40C78.916 18.6792 61.7368 1.5 40.416 1.5C19.0953 1.5 1.91602 18.6792 1.91602 40C1.91602 61.3208 19.0953 78.5 40.416 78.5Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3685 22.7905H46.4615C45.6912 22.7905 45.0661 23.4156 45.0661 24.1859C45.0661 24.9561 45.6912 25.5812 46.4615 25.5812H51.0001L46.1973 30.384C44.0503 28.8259 41.4103 27.9068 38.5545 27.9068C31.3619 27.9068 25.5312 33.7375 25.5312 40.9301C25.5312 48.1226 31.3619 53.9533 38.5545 53.9533C45.7471 53.9533 51.5778 48.1226 51.5778 40.9301C51.5778 37.5998 50.3275 34.5608 48.2699 32.2575L52.9731 27.5542V32.0929C52.9731 32.8631 53.5982 33.4882 54.3685 33.4882C55.1387 33.4882 55.7638 32.8631 55.7638 32.0929V24.1859C55.7638 23.4156 55.1387 22.7905 54.3685 22.7905ZM48.7871 40.9301C48.7871 46.5812 44.2057 51.1626 38.5545 51.1626C32.9033 51.1626 28.3219 46.5812 28.3219 40.9301C28.3219 35.2789 32.9033 30.6975 38.5545 30.6975C44.2057 30.6975 48.7871 35.2789 48.7871 40.9301Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 85.0653,
    y1: 39.9525,
    x2: 1.91754,
    y2: 40.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00386572,
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467426,
    stopColor: "#B386AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB0F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 58.1782,
    y1: 38.3527,
    x2: 25.5318,
    y2: 38.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00386572,
    stopColor: "#F2994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467426,
    stopColor: "#B386AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BB0F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.415039)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMan);
export default __webpack_public_path__ + "static/media/iconMan.25aec944.svg";
export { ForwardRef as ReactComponent };